var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8047 0.175736C12.0651 0.410051 12.0651 0.78995 11.8047 1.02426L6.4714 5.82426C6.21105 6.05858 5.78894 6.05858 5.5286 5.82426L0.195262 1.02426C-0.0650875 0.78995 -0.0650874 0.41005 0.195262 0.175736C0.455611 -0.0585787 0.877722 -0.0585786 1.13807 0.175736L6 4.55147L10.8619 0.175736C11.1223 -0.0585782 11.5444 -0.0585782 11.8047 0.175736Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.a6c3c4d467d162643ba5c036ea1235f7.svg";
export { ForwardRef as ReactComponent };